// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}

h2 {
  color: #000;
  font-size: 25px;
  font-weight: 700;
  line-height: 35px;
}

.ratings-section {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
}

ngu-carousel::ng-deep {
  height: 100%;
  width: 100%;
}
ngu-carousel::ng-deep .ngu-container {
  height: 100%;
}
ngu-carousel::ng-deep .ngucarousel, ngu-carousel::ng-deep .ngu-touch-container {
  height: 100%;
}
ngu-carousel::ng-deep .ngu-touch-container {
  margin: 0;
}
ngu-carousel::ng-deep ngu-tile {
  width: 100%;
  flex: 100% 0 0;
}
ngu-carousel::ng-deep .tile {
  height: 100%;
  box-shadow: none;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/page/components/product/components/product-ratings-section/product-ratings-section.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,YAAA;EACA,WAAA;AAFF;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAME;EACE,SAAA;AAJJ;AAOE;EACE,WAAA;EACA,cAAA;AALJ;AAQE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AANJ","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n:host {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  align-self: stretch;\n}\n\nh2 {\n  color: #000;\n\n  font-size: 25px;\n  font-weight: 700;\n  line-height: 35px;\n}\n\n.ratings-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  width: 100%;\n}\n\nngu-carousel::ng-deep {\n  height: 100%;\n  width: 100%;\n\n  .ngu-container {\n    height: 100%;\n  }\n\n  .ngucarousel, .ngu-touch-container {\n    height: 100%;\n  }\n\n  .ngu-touch-container {\n    margin: 0;\n  }\n\n  ngu-tile {\n    width: 100%;\n    flex: 100% 0 0;\n  }\n\n  .tile {\n    height: 100%;\n    box-shadow: none;\n    display: flex;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
